<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="copyright text-center text-sm text-muted">
            <a href="https://gsit.ly/" class="company-link" target="_blank">
             ©{{ $t("footer.company") }}
            </a>
            <span class="text-muted">, {{ $t("footer.copyright") }}</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped></style>
